// URLs y endpoints externos del sitio Génika
// Se pueden sobrescribir via variables Vite (VITE_*) en Web/frontend/.env
// - En build de Docker producción, se inyectan al construir la imagen
// - En dev local, tomar los defaults es suficiente

export const BACKOFFICE_URL =
  import.meta.env.VITE_BACKOFFICE_URL || 'http://127.0.0.1:8082'

export const PUBLIC_SITE_URL =
  import.meta.env.VITE_PUBLIC_SITE_URL || 'http://127.0.0.1:8082'

// Helpers para armar rutas del Backoffice
export const backofficeLoginUrl = (portal) =>
  `${BACKOFFICE_URL}/login${portal ? `?portal=${portal}` : ''}`

// Mapeo de rutas del antiguo /admin/* del Web al Backoffice equivalente.
// Cualquier ruta no listada cae al dashboard `/`.
const ADMIN_PATH_MAP = {
  '': '/',
  blog: '/blog',
  comments: '/blog', // los comentarios viven como tab dentro de Blog en el BO
  forum: '/forum',
  products: '/products',
  banners: '/banners',
  team: '/team',
  faq: '/faq',
  testimonials: '/testimonials',
  contacts: '/contact',
  settings: '/settings',
  alliances: '/alliances',
  stats: '/stats',
  profile: '/profile',
  legal: '/legal',
  downloadables: '/downloadables',
}

export function mapAdminPathToBackoffice(adminSubpath) {
  const key = String(adminSubpath || '')
    .replace(/^\/+|\/+$/g, '')
    .split('/')[0]
  return ADMIN_PATH_MAP[key] ?? '/'
}
